<template>
  <div class="enery-dispaly">
    <div class="display-box">
      <div class="display-item">
        <EnergyStatistics></EnergyStatistics>
      </div>
      <div class="display-item">
        <ElectricityTrendMonth></ElectricityTrendMonth>
      </div>
    </div>
    <div class="display-box">
      <div class="display-item">
        <ElectricityTrendDay></ElectricityTrendDay>
      </div>
      <div class="display-item">
        <ElectricityTrendYear></ElectricityTrendYear>
      </div>
    </div>
  </div>
</template>

<script>
import EnergyStatistics from '../components/EnergyStatistics';
import ElectricityTrendYear from '../components/ElectricityTrendYear';
import ElectricityTrendMonth from '../components/ElectricityTrendMonth';
import ElectricityTrendDay from '../components/ElectricityTrendDay';
export default {
  name: 'EnergyDisplay',
  components: {
    EnergyStatistics,
    ElectricityTrendYear,
    ElectricityTrendMonth,
    ElectricityTrendDay
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.enery-dispaly {
  width: 100%;
  height: 100%;
  display: flex;

  .display-box {
    flex: 1;
    display: flex;
    flex-direction: column;

    .display-item {
      flex: 1;
      background-color: #ffffff;
    }
  }

  .display-box:not(:first-child) {
    margin-left: 10px;
  }

  .display-item:not(:first-child) {
    margin-top: 10px;
  }
}
</style>